/**
 * Smart Search user-feedback helpers for pathway-xp-api.
 *
 * Clients call `PUT /smart-search-feedback/{traceId}` via
 * {@link @cfa/pathway-fe-shared/xp upsertSmartSearchFeedback}.
 */

/** Matches `SmartSearchFeedbackRequest.comment` max length on pathway-xp-api. */
export const SMART_SEARCH_FEEDBACK_COMMENT_MAX_LENGTH = 2000;

export type SmartSearchUserFeedbackValue = 0 | 1;

/** Body for `PUT /smart-search-feedback/{traceId}` (pathway-xp-api). */
export interface SmartSearchXpFeedbackRequestBody {
  value: SmartSearchUserFeedbackValue;
  /** Use null when there is no comment (matches `SmartSearchFeedbackRequest`). */
  comment: string | null;
}

export const smartSearchThumbsToFeedbackValue = (
  thumbsUp: boolean,
): SmartSearchUserFeedbackValue => (thumbsUp ? 1 : 0);

export const buildSmartSearchXpFeedbackRequestBody = ({
  value,
  comment,
}: {
  value: SmartSearchUserFeedbackValue;
  comment?: string | null;
}): SmartSearchXpFeedbackRequestBody => {
  const trimmed = comment?.trim();
  if (!trimmed) {
    return { value, comment: null };
  }
  return { value, comment: trimmed };
};
